import { render, staticRenderFns } from "./modaLateralCrear.vue?vue&type=template&id=6ef77969&scoped=true&"
import script from "./modaLateralCrear.vue?vue&type=script&lang=js&"
export * from "./modaLateralCrear.vue?vue&type=script&lang=js&"
import style0 from "./modaLateralCrear.vue?vue&type=style&index=0&id=6ef77969&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef77969",
  null
  
)

export default component.exports